import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'jow-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    standalone: false
})
export class NotificationDialogComponent  {
  level: string;
  title: string;
  message: string;

  constructor(@Inject(MAT_DIALOG_DATA) {level, title, message}) {
    this.message = message;
    this.title = title;
    this.level = level;
  }
}
